<template>
  <div class="add-new__brand">
    <div class="bg-color__fff">
      <div class="form-wrapper">
        <el-form
          label-position="right"
          label-width="auto"
          :model="form"
          :inline="true"
        >
          <el-form-item label="商标所在国别：">
            <div class="input">
              <el-select v-model="form.countryId" placeholder="请选择">
                <el-option
                  v-for="item in filterDownData('countryList')"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </div>
          </el-form-item>
          <el-form-item label="资质类型：">
            <el-radio-group v-model="form.qualificationType">
              <el-radio :label="'1'">商标注册证</el-radio>
              <el-radio :label="'2'">商标受理通知书</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="商标类型：">
            <div class="input">
              <el-select v-model="form.typeId" placeholder="请选择">
                <el-option
                  v-for="item in filterDownData('trademartksList')"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </div>
          </el-form-item>
          <el-form-item label="商标有效期：" class="datepick">
            <div class="input ">
              <el-date-picker
                v-model="form.time"
                type="daterange"
                unlink-panels
                range-separator="至 "
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                format="yyyy 年 MM 月 dd 日"
                value-format="yyyy-MM-dd"
                :picker-options="pickerOptions"
              />
            </div>
          </el-form-item>
          <el-form-item label="商标申请/商标注册号：">
            <div class="input">
              <el-input v-model="form.brandMark" placeholder="请输入" />
            </div>
          </el-form-item>
          <el-form-item label="商标注册人：">
            <div class="input">
              <el-input
                v-model="form.trademarkRegistrant"
                placeholder="请输入中文名"
              />
            </div>
          </el-form-item>
          <el-form-item label="品牌名称：">
            <div class="input">
              <el-input v-model="form.cnName" placeholder="请输入中文名称" />
            </div>
          </el-form-item>
          <el-form-item label="品牌类型：">
            <div class="input">
              <el-select v-model="form.brandType" placeholder="请选择">
                <el-option
                  :label="item.label"
                  :value="item.value"
                  v-for="item in filterDownData('brandType')"
                  :key="item.value"
                />
              </el-select>
            </div>
          </el-form-item>
          <el-form-item label="." class="hidden">
            <div class="input">
              <el-input v-model="form.enName" placeholder="请输入英文名称" />
            </div>
          </el-form-item>
          <el-form-item label="商家经营商品清单：">
            <el-upload
              :class="form.auditStatus === '2' && 'noDel'"
              action="/"
              ref="uploadFile"
              :on-remove="handleRemove.bind(null, 'form.fileList')"
              :limit="1"
              accept=".xls,.xlsx"
              :before-upload="_beforeLimitUpload"
              :http-request="
                _appendFormDataInfo.bind(
                  null,
                  form.fileList,
                  'commodities_list_url'
                )
              "
              :on-change="handleAddItemData.bind(null, 'form.fileList')"
              :file-list="form.fileList"
              :auto-upload="false"
            >
              <el-button size="medium" class="sub-color">上传</el-button>
              <div slot="tip" class="el-upload__tip">
                （只能上传excel文件）
              </div>
            </el-upload>
            <fragment v-if="form.fileList.length >= 1">
              <i class="el-icon-download"></i>
              <a class="download" :href="form.listUrl" download="模板">
                下载模板
              </a>
            </fragment>
          </el-form-item>
        </el-form>
      </div>
      <div class="drag-upload__block">
        <h3 class="title">
          商标注册证/品牌授权书/公司资质文件上传区域：
          <span class="tips">
            （请务必将资质文件作为第一张上传，作为主要审核之用）
          </span>
        </h3>
        <el-upload
          action="/"
          ref="uploadImg"
          list-type="picture-card"
          accept=".jpg,.jpeg,.png"
          :limit="10"
          :on-exceed="handleExceed"
          :on-preview="handlePictureCardPreview"
          :on-remove="handleRemove.bind(null, 'form.imgList')"
          :http-request="
            _appendFormDataInfo.bind(null, form.imgList, 'brand_file')
          "
          :file-list="form.imgList"
          :before-upload="_beforeLimitUpload"
          :on-change="handleAddItemData.bind(null, 'form.imgList')"
          :auto-upload="false"
        >
          <i class="el-icon-plus" />
        </el-upload>
        <el-dialog :visible.sync="dialogVisible">
          <div class="img-viewer">
            <img width="100%" :src="dialogImageUrl" alt="" />
          </div>
        </el-dialog>
      </div>
      <div class="btn-all">
        <el-button
          v-permission:save="$route.meta.permission"
          @click="saveData"
          size="98"
          class="sub-color"
        >
          保存
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import pickerOptions from 'mixins/pickerOptions/'
import uploadImg from 'mixins/uploadImg'
import filterDownData from 'mixins/filterDownData'

export default {
  name: 'addNewBrand',
  mixins: [pickerOptions, uploadImg, filterDownData],
  data() {
    this.keyMap = {
      brand_info: {
        name: 'form',
        audit_status: 'auditStatus',
        brand_mark: 'brandMark',
        brand_image: 'imgList',
        commodities_list_url: 'listUrl',
        brand_type: 'brandType',
        chinese_name: 'cnName',
        country_id: 'countryId',
        start_time: 'startTime',
        end_time: 'endTime',
        file_data: 'fileList',
        english_name: 'enName',
        qualification_type: 'qualificationType',
        trademark_registrant: 'trademarkRegistrant',
        type_id: 'typeId',
        picture_url: 'url',
        status: 'status',
        album_id: 'albumId',
        picture_name: 'picName',
        mark: 'mark',
        class_name: 'className',
        add_time: 'addTime',
        use_state: 'useState',
        sort: 'sort'
      }
    }
    return {
      form: {
        imgList: [],
        fileList: []
      },
      dialogImageUrl: '',
      dialogVisible: false
    }
  },
  created() {
    if (this.$route.query.brand_id) {
      this._getBrandDetails(this.$route.query)
    }
  },
  beforeRouteUpdate(to, from, next) {
    if (to.query.brand_id) {
      this._getBrandDetails(to.query)
    }
    next()
  },
  methods: {
    /**
     * 获取品牌详情
     * @param params
     * @private
     */
    _getBrandDetails(params) {
      this.api.getBrandDetails(params).then(res => {
        this.utils._modifyObjKey(res, this.keyMap)
        this.form = res.form
        this.utils._mergeTime(this, 'form')
      })
    },
    /**
     * 保存数据
     */
    saveData() {
      this.utils._setNewTime(this, 'form')
      const newKeyMap = this.utils._reverseObj(this.keyMap)
      const newForm = {
        form: this.utils._cloneDeep(this.form)
      }
      this.utils._modifyObjKey(newForm, newKeyMap)
      const id = this.$route.query.brand_id
      if (id) {
        newForm.brand_info.brand_id = this.$route.query.brand_id
      }
      this._handleUpload('uploadImg', 'uploadFile')
      this.formData.append('data', JSON.stringify(newForm.brand_info))
      if (this.isUpload) {
        this.api.saveBrandFormData(this.formData).then(() => {
          this.$notify({
            type: 'success',
            message: '保存成功~！'
          })
          this.$router.go(-1)
        })
      }
    }
  }
}
</script>

<style lang="scss">
.add-new__brand {
  .bg-color__fff {
    padding: 4.4rem 10rem 4.7rem 3rem;
    @include maxScreenWidth(1366) {
      padding-right: 1rem;
      padding-left: 1rem;
    }
  }

  .noDel {
    .el-icon-close {
      display: none;
    }
  }

  .form-wrapper {
    .el-form-item {
      width: 50%;
      margin-right: 0;
      @include maxScreenWidth(1440) {
        width: auto;
      }
    }

    .el-icon-download {
      font-size: 16px;
    }

    .download {
      text-decoration: underline;
      color: #000;
    }

    .hidden {
      label {
        opacity: 0;
      }
    }
  }

  .drag-upload__block {
    width: 100%;
    min-height: 30rem;
    border: solid 1px #e1e1e1;
    padding: 4.3rem 0 4.6rem 3.3rem;
    margin-top: 4.4rem;

    .title {
      font-size: 1.1rem;
      margin-bottom: 5.3rem;
    }

    .tips {
      font-size: 0.9rem;
    }

    .el-upload,
    .el-upload-list__item {
      position: relative;
      width: 12.5rem;
      height: 12.5rem;
      background-color: #f7f7f7;
      border: 0;
    }

    .el-icon-plus {
      font-family: 'iconfont' !important;
      @include transCenter(absolute, 50%, 50%);

      &:before {
        content: '\e67c';
      }
    }
  }

  .btn-all {
    margin-top: 4.6rem;
    text-align: center;
  }
}
</style>
